import { useNavigate } from 'react-router-dom';
import { buildNewChatLocationState, isChatNewRoute } from '../chat-session-intent';
import { ModeSelector } from '@/components/mode-selector';
import type { ChatSessionIntent } from '../chat-session-intent';

type ChatSpaceSwitcherProps = {
  className?: string;
  onValueChange: (intent: ChatSessionIntent) => void;
  value: ChatSessionIntent;
};

const CHAT_SPACE_OPTIONS = [
  {
    value: 'general' as const,
    label: 'Chat',
    description: 'Discuter librement avec l’assistant',
  },
  {
    value: 'document-search' as const,
    label: 'RAG',
    description: 'Interroger la base documentaire',
  },
];

export function ChatSpaceSwitcher({ className, onValueChange, value }: ChatSpaceSwitcherProps) {
  return (
    <ModeSelector
      className={className}
      value={value}
      options={CHAT_SPACE_OPTIONS}
      onValueChange={onValueChange}
      aria-label="Espace conversation"
      data-testid="chat-space-switcher"
      getOptionTestId={(optionValue) =>
        optionValue === 'document-search' ? 'chat-space-rag' : 'chat-space-chat'
      }
    />
  );
}

export function ChatSpaceNavigation({ value, entryPath }: {
  value: ChatSessionIntent;
  entryPath: (intent: ChatSessionIntent) => string;
}) {
  const navigate = useNavigate();
  return <ChatSpaceSwitcher value={value} onValueChange={(intent) => {
    if (intent === value) return;
    const path = entryPath(intent);
    navigate(path, { state: isChatNewRoute(path) ? buildNewChatLocationState() : undefined });
  }} />;
}
